import type { Role } from "../types";

export const ROLE_LABELS: Record<Role, string> = {
  player: "Jogador",
  moderator: "Moderador",
  admin: "Admin",
};

/** "14:30" se for hoje, "05/10 14:30" se for outro dia. null = permanente. */
export function formatUntil(iso: string | null): string {
  if (!iso) return "permanente";
  const date = new Date(iso);
  const time = date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  if (date.toDateString() === new Date().toDateString()) return `até ${time}`;
  return `até ${date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" })} ${time}`;
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}
